import React, { useState } from "react";
import AuthLayout from "../blocs/AuthLayout";
import RegisterForm from "./auth/registerForm";
import { Helmet } from "react-helmet-async";

const Register = () => {
  return (
    <AuthLayout
      image="../images/Twynyinscription.jpg"
      title="Réservez tous vos <strong>services pros </strong>, quand et où vous voulez."
    >
      <Helmet>
        <title>Page Registre</title>
        <meta name="description" content="Page Inscription client" />
      </Helmet>
      <RegisterForm from="login" />
    </AuthLayout>
  );
};

export default Register;
